import {TableConfig} from '@shared/interfaces/table/table-config';
import {BusinessTransactionDto} from '@app/api/dmc';
import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const chargeinformationBusinesstransactionsTable: TableConfig<BusinessTransactionDto> = {
  selectable: true,
  selectableType: "single",
  columns: [
    {
      title: 'businessTransactions.pipelineType',
      key: 'pipelineType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams:
        {
          notspecified: 'enum.pipelinetype.notspecified',
          request: 'enum.pipelinetype.request',
          response: 'enum.pipelinetype.response',
          notify: 'enum.pipelinetype.notify',
          todo: 'enum.pipelinetype.todo',
          todohandled: 'enum.pipelinetype.todohandled',
        }
    },
    {
      title: 'businessTransactions.rsmNumber',
      key: 'rsmNumber'
    },
    {
      title: 'businessTransactions.rsmName',
      key: 'rsmName'
    },
    {
      title: 'businessTransactions.businessReasonCode',
      key: 'businessReasonCode'
    },
    {
      title: 'businessTransactions.createdTS',
      key: 'createdTS'
    },
    {
      title: 'businessTransactions.actionRespondedTS',
      key: 'actionRespondedTS'
    },
    {
      title: 'businessTransactions.createdBy',
      key: 'createdBy'
    }
  ]
}
